import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PatternIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pattern"}/>
}
